<div class="auth_page">
  <!-- What Smart TOS is: brand, one-line purpose and a top-down yard plan -->
  <section class="story" aria-label="About Smart TOS">
    <div class="brand">
      <img src="assets/images/smarttos-logo-small.svg" alt="" width="32" height="36" />
      <span class="wordmark">Smart TOS</span>
    </div>

    <div class="story_body">
      <h2 class="headline">Every container, from gate-in to gate-out.</h2>
      <p class="lede">
        Gate, yard, tally, job orders, customs filings and billing for container freight stations and terminals,
        run from one system.
      </p>

      <figure class="yard" aria-hidden="true">
        <svg [attr.viewBox]="'0 0 ' + yard.width + ' ' + yard.height" preserveAspectRatio="xMinYMin meet">
          @for (bay of yard.bays; track bay.label) {
            <text class="bay_label" [attr.x]="bay.x" y="9">{{ bay.label }}</text>
          }
          @for (row of yard.rows; track row.label) {
            <text class="row_label" x="4" [attr.y]="row.y">{{ row.label }}</text>
          }
          @for (block of yard.blocks; track $index) {
            <rect [attr.x]="block.x" [attr.y]="block.y" [attr.width]="block.w" [attr.height]="blockHeight" rx="1.5"
                  [attr.class]="'box tier_' + block.tier + (block.arriving ? ' arriving' : '')"></rect>
          }
        </svg>
      </figure>

      <ol class="journey" aria-label="A container's journey through Smart TOS">
        @for (stop of journey; track stop) {
          <li>{{ stop }}</li>
        }
      </ol>
    </div>

    <p class="legal">&copy; {{ year }} CNB Logitech Pvt. Ltd.</p>
  </section>

  <main class="access">
    <div class="access_inner">
      <img class="tenant_logo" src="assets/images/logo.png" alt="SmartTOS | Globicon" width="276" height="44" />
      <ng-content></ng-content>
    </div>
  </main>
</div>
